import 'reflect-metadata';
import { Expose, plainToInstance, instanceToPlain } from 'class-transformer';

export class HomeBinary {
  @Expose({ name: 'total_bonus' })
  totalBonus: string;

  position: number;

  @Expose({ name: 'total_left' })
  leftPoints: string;

  @Expose({ name: 'total_right' })
  rightPoints: string;

  @Expose({ name: 'carry_left' })
  leftCarry: string;

  @Expose({ name: 'carry_right' })
  rightCarry: string;

  @Expose({ name: 'left_downline_count' })
  leftDownlinesCount: number;

  @Expose({ name: 'right_downline_count' })
  rightDownlinesCount: number;

  @Expose({ name: 'default_leg' })
  defaultLeg?: string;

  @Expose({ name: 'placement_first_name' })
  placementFirstName: string;

  @Expose({ name: 'placement_last_name' })
  placementLastName?: string;

  @Expose({ name: 'sponsor_first_name' })
  sponsorFirstName: string;

  @Expose({ name: 'sponsor_last_name' })
  sponsorLastName?: string;

  constructor(
    totalBonus: string,
    position: number,
    leftPoints: string,
    rightPoints: string,
    leftCarry: string,
    rightCarry: string,
    leftDownlinesCount: number,
    rightDownlinesCount: number,
    defaultLeg: string | undefined,
    placementFirstName: string,
    placementLastName: string | undefined,
    sponsorFirstName: string,
    sponsorLastName: string | undefined
  ) {
    this.totalBonus = totalBonus;
    this.position = position;
    this.leftPoints = leftPoints;
    this.rightPoints = rightPoints;
    this.leftCarry = leftCarry;
    this.rightCarry = rightCarry;
    this.leftDownlinesCount = leftDownlinesCount;
    this.rightDownlinesCount = rightDownlinesCount;
    this.defaultLeg = defaultLeg;
    this.placementFirstName = placementFirstName;
    this.placementLastName = placementLastName;
    this.sponsorFirstName = sponsorFirstName;
    this.sponsorLastName = sponsorLastName;
  }

  static fromJson(json: Record<string, any>): HomeBinary {
    return plainToInstance(HomeBinary, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
